import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, WineIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} comprehensive volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="bg-stage-deep tech-grid relative isolate overflow-hidden" data-id="element-103" data-mp="sai2qz5n6n4o">
      <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-104" data-mp="ncgiiawhchrm" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-105" data-mp="neavn31if5l5">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-md border border-sage/50 bg-sage/15 px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-sageGlow" data-id="element-106" data-mp="3d2tln1u126au">
          <WineIcon className="h-4 w-4" aria-hidden="true" data-id="element-107" data-mp="39autvl4lu10x" /> Wine Studies &amp; Oenology Teacher Ready
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.05] text-white sm:text-5xl lg:text-6xl" data-id="element-108" data-mp="3e84nlcz10yuk">
          Master Your Year of Wine Education
          <br data-id="element-109" data-mp="2vietyt702j48" />
          <span className="text-gold" data-id="element-110" data-mp="2vjzq2n8yqa47">in One Afternoon.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-111" data-mp="2hinawe1mmcjd">
          <img src={productImage} alt="Wine Studies & Oenology Teacher Ready: nine volumes and five bonuses covering viticulture, winemaking, aging, sensory analysis, wine regions and hospitality" className="mx-auto w-full rounded-xl drop-shadow-[0_24px_44px_rgba(0,0,0,.7)]" data-id="element-112" data-mp="s3cki77jpdoz" />
        </motion.div>

        <div className="mt-9" data-id="element-113" data-mp="1b0nmw0oh4n8n">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-114" data-mp="1azkufobi6cqm">
            Get your Teacher Ready now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-onDark" data-id="element-115" data-mp="112pud0zl04a8">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-md border border-forest bg-forest/70 px-3 py-2" data-id="element-116" data-mp="x0l50eg61tte">
              <Icon className="h-3.5 w-3.5 text-sageGlow" aria-hidden="true" data-id="element-117" data-mp="3hr3sjxze2f6v" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}